"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileButtons = exports.DesktopButtons = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const media_1 = require("../../../../../utils/media");
const MobileButtons = styled_components_1.default.div `
  display: flex;
  gap: 24px;
  @media ${media_1.media.desktop} {
    display: none;
  }
`;
exports.MobileButtons = MobileButtons;
const DesktopButtons = styled_components_1.default.div `
  display: none;

  @media ${media_1.media.desktop} {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }
`;
exports.DesktopButtons = DesktopButtons;
